module.exports = __webpack_public_path__ + "static/img/class_3.7fd20b45.jpg";